import { route } from 'frontend/inertia/routes'

export const learningPlansPath = {
  // mirrors frontend_academy_partner_learning_plans
  index: route('/academy_partner/learning_plans'),
  // mirrors new_frontend_academy_partner_learning_plan
  new: route('/academy_partner/learning_plans/new'),
  // mirrors frontend_academy_partner_learning_plan
  show: route('/academy_partner/learning_plans/:id'),
  // mirrors edit_frontend_academy_partner_learning_plan
  edit: route('/academy_partner/learning_plans/:id/edit'),
}
